module.exports = __webpack_public_path__ + "static/media/engineering-hero.e1cc2471.jpg";